import { render } from "./PhotoCell.vue?vue&type=template&id=6b9f77a0&scoped=true&bindings={\"photo\":\"props\",\"isHover\":\"setup\",\"getPhotoImage\":\"setup\"}"
import script from "./PhotoCell.vue?vue&type=script&lang=js"
export * from "./PhotoCell.vue?vue&type=script&lang=js"

import "./PhotoCell.vue?vue&type=style&index=0&id=6b9f77a0&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-6b9f77a0"

export default script